import { useDashboardAnalytics } from "@/hooks/use-dashboard-analytics";
import { useValuesVisibility } from "@/hooks/use-values-visibility";
import { Eye, EyeOff, TrendingUp, TrendingDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function HeaderBalanceBar() {
  const { monthlyComparison, isLoading } = useDashboardAnalytics();
  const { visible, toggle, mask } = useValuesVisibility();

  const formatCurrency = (value: number) =>
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);

  const income = monthlyComparison.currentMonthIncome;
  const expense = monthlyComparison.currentMonthExpenses;
  const balance = income - expense;

  if (isLoading) return null;

  return (
    <div className="flex items-center gap-3 ml-auto">
      {/* Income */}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="hidden sm:flex items-center gap-1 text-sm text-success">
              <TrendingUp className="h-3.5 w-3.5" />
              <span className="font-semibold">{mask(formatCurrency(income))}</span>
            </div>
          </TooltipTrigger>
          <TooltipContent><p>Receitas do mês</p></TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {/* Expense */}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="hidden sm:flex items-center gap-1 text-sm text-destructive">
              <TrendingDown className="h-3.5 w-3.5" />
              <span className="font-semibold">{mask(formatCurrency(expense))}</span>
            </div>
          </TooltipTrigger>
          <TooltipContent><p>Despesas do mês</p></TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {/* Separator */}
      <div className="hidden sm:block h-5 w-px bg-border" />

      {/* Balance - more prominent */}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex items-center gap-1 text-base font-bold text-primary">
              <span>{mask(formatCurrency(balance))}</span>
            </div>
          </TooltipTrigger>
          <TooltipContent><p>Saldo do mês (receitas - despesas)</p></TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {/* Eye toggle */}
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        onClick={toggle}
        aria-label={visible ? "Ocultar valores" : "Mostrar valores"}
      >
        {visible ? (
          <Eye className="h-4 w-4 text-muted-foreground" />
        ) : (
          <EyeOff className="h-4 w-4 text-muted-foreground" />
        )}
      </Button>
    </div>
  );
}
